<template>
    <div :class="{ 'row full-height no-wrap overflow-hidden': compactView }">
        <div :class="{ 'flex-basis-75': compactView }">
            <div v-if="!compactView">
                <QitButton
                    color="secondary"
                    class="border"
                    :icon="mode === 'selected' ? 'fa-regular fa-cloud-arrow-up' : 'fa-regular fa-arrow-left'"
                    :label="mode === 'selected' ? $t('shared.Upload another photo') : $t('shared.Take new photo')"
                    @click="$emit('onRenew')"
                />
            </div>
            <div class="cropper-box" :class="{ 'q-my-lg': $q.screen.gt.sm, 'q-my-md': $q.screen.lt.md }">
                <div v-if="loading" class="flex justify-center items-center cropper loading-box">
                    <q-spinner-ios size="2em" />
                </div>
                <Cropper
                    class="cropper"
                    :src="image"
                    @change="onChange"
                    @ready="onReady"
                    background-class="cropper-background"
                />
            </div>
        </div>
        <div class="flex">
            <div class="flex" :class="{ 'full-width row no-wrap': !compactView, 'q-pl-sm column': compactView }">
                <div v-if="compactView">
                    <div class="flex flex-grow">
                        <QitButton
                            color="secondary"
                            class="border"
                            :icon="mode === 'selected' ? 'fa-regular fa-cloud-arrow-up' : 'fa-regular fa-arrow-left'"
                            :label="
                                mode === 'selected' ? $t('shared.Upload another photo') : $t('shared.Take new photo')
                            "
                            @click="$emit('onRenew')"
                        />
                    </div>
                </div>
                <div :class="{ buttons: compactView, 'full-width row no-wrap gap-l': !compactView }">
                    <div :class="{ 'flex-basis-50': !compactView }">
                        <div>
                            <QitButton
                                color="secondary"
                                class="border full-width"
                                icon="fa-regular fa-expand"
                                :label="$t('shared.Reset')"
                                @click="$emit('onReset')"
                            />
                        </div>
                    </div>
                    <div :class="{ 'flex-basis-50': !compactView }">
                        <div>
                            <QitButton
                                class="full-width"
                                color="primary"
                                icon="fa-regular fa-magnifying-glass"
                                :label="$t('shared.Start search')"
                                @click="$emit('onSearch')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, toRefs } from "vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { ImageMode } from "@/shared/part-recognition/dialog/part-recognition-dialog.vue";

const props = defineProps<{ image: string; mode: ImageMode; compactView: boolean }>();
const emits = defineEmits<{ onCropChange: [blob: Blob]; onReset: []; onRenew: []; onSearch: [] }>();

const { image } = toRefs(props);
const loading = ref<boolean>(true);

const onReady = () => {
    loading.value = false;
};

const onChange = ({ canvas }: { canvas: HTMLCanvasElement }) => {
    if (!canvas) return;

    canvas.toBlob((blob) => {
        if (!blob) {
            console.error("Canvas to blob failed");
            return;
        }

        emits("onCropChange", blob);
    }, "image/jpeg");
};
</script>

<style lang="scss" scoped>
:deep(.cropper-background) {
    background: $grey-20;
}
</style>
